export default __webpack_public_path__ + "static/media/Fabletics2-orig.18b295eb.jpg";